(function() {
    angular.module("app").controller("ResetDisplayMinutesController", ResetDisplayMinutesController)

    ResetDisplayMinutesController.$inject = [
        "$scope",
        "$uibModalInstance",
        "trackersService",
        "trackerID",
        "onSuccess",
        "onFailure",
        "onReset",
        "onCancel",
        "resetLifetime"
    ]

    function ResetDisplayMinutesController(
        $scope,
        $uibModalInstance,
        trackersService,
        trackerID,
        onSuccess,
        onFailure,
        onReset,
        onCancel,
        resetLifetime
    ){
        "use strict"

        $scope.resetLifetime = resetLifetime

        $scope.reset = function( ) {

            onReset()

            if ($scope.resetLifetime) {
                $uibModalInstance.close(
                    trackersService.resetDisplayMinutesBoth(trackerID, onSuccess, onFailure)
                )
            } else {
                $uibModalInstance.close(
                    trackersService.resetDisplayMinutes(trackerID, onSuccess, onFailure)
                )
            }
        }

        $scope.cancel = function() {
            onCancel()
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
